import { compareNumbers } from "./number"
import { compareStrings } from "./strings"

export const createCustomSort = customSorters => {
  return (items, index, isDesc) => {
    if (index[0] !== undefined) {
      items.sort((a, b) => {
        const comparison = customCompare(
          a[index[0]],
          b[index[0]],
          (customSorters || {})[index[0]],
          a,
          b
        )
        if (!isDesc[0]) {
          return comparison
        } else {
          return comparison > 0 ? -1 : 1
        }
      })
    }

    return items
  }
}

const customCompare = (aValue, bValue, customSorter, a, b) => {
  if (customSorter !== undefined) {
    if (customSorter === "string") {
      return compareStrings(aValue, bValue)
    } else if (customSorter === "number") {
      return compareNumbers(aValue, bValue)
    } else if (typeof customSorter === "object" && customSorter !== null) {
      if (customSorter.type === "string") {
        return compareStrings(
          customSorter.transform ? customSorter.transform(aValue, a) : aValue,
          customSorter.transform ? customSorter.transform(bValue, b) : bValue
        )
      } else if (customSorter.type === "number") {
        return compareNumbers(
          customSorter.transform ? customSorter.transform(aValue, a) : aValue,
          customSorter.transform ? customSorter.transform(bValue, b) : bValue
        )
      }
    } else {
      return customSorter(aValue, bValue)
    }
  } else {
    return defaultCompare(aValue, bValue)
  }
}

const defaultCompare = (aValue, bValue) => {
  if (!aValue) {
    return -1
  } else if (!bValue) {
    return 1
  } else if (typeof aValue === "string" || aValue instanceof String) {
    return compareStrings(aValue, bValue)
  } else {
    return aValue < bValue ? -1 : 1
  }
}
